import { Component, Input } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import { VALIDATION_ERRORS_MESSAGE } from '../../../constants/validation-errors.const';
import {environment} from "../../../../environments/environment";
import {ValidationService} from "../validation.service";
import detectMobile from "../../../utils/detect-mobile";

@Component({
  selector: 'app-gender-box',
  templateUrl: './gender-box.component.html',
  styleUrls: ['./gender-box.component.sass'],
})
export class GenderBoxComponent {
  public brand = environment.brand;
  public isChecked: boolean;

  public ERRORS_MESSAGE = VALIDATION_ERRORS_MESSAGE;

  public isMobile = detectMobile();

  @Input() formGroup: FormGroup;
  @Input() fieldName: string;
  @Input() label: string;
  @Input() disableRequiredIdentifier: boolean = false;
  @Input() disableRequiredIdentifierLabel: boolean = false;

  public genders: any[] = [
    { label: 'Мужчина', value: 'MALE' },
    { label: 'Женщина', value: 'FEMALE' },
  ];

  public get control() {
    return this.formGroup.get(this.fieldName) as FormControl;
  }

  public validation() {
    return ValidationService.getValidationClass(
      this.formGroup.get(this.fieldName) as FormControl, this.brand, this.disableRequiredIdentifier
    );
  }

  public formatFieldName(title) {
    return  this.isMobile && this.disableRequiredIdentifierLabel ? title + ' *' : title
  }
}
